import React, {useState, useRef, useEffect} from 'react';
import { Link } from 'react-router-dom';
import { Alert, Button, Card, Col, Container, Row, Input, Label } from 'reactstrap';
import axios from 'axios';
import ReactInputVerificationCode from 'react-input-verification-code';
import { useInterval } from "usehooks-ts";

import logoTelkom from "../../../assets/images/telkom/logoACI.png";
import Welcome from "../../../assets/images/telkom/lupa.png";

const CoverPasswReset = () => {
    document.title="Forgot Password";

    // ------- Input Email --------- //
    const [email, setEmail] = useState('');
    const [otp, setOTP] = useState('');
    const [apiKey, setApiKey] = useState('');
    const [password, setPassword] = useState('');
    const [confPassword, setConfPassword] = useState('');
    const [errorEmail, setErrorEmail] = useState(true);
    const [errorMessageEmail, setErrorMessageEmail] = useState('');
    const [successEmail, setSuccessEmail] = useState(true);
    const [errorOTP, setErrorOTP] = useState(true);
    const [errorMessageOTP, setErrorMessageOTP] = useState('');
    const [errorPassword, setErrorPassword] = useState(true);
    const [errorKontenPassword, setErrorKontenPassword] = useState('');

    // -- Tombol Show Password -- //
    const [showPass, setShowPass] = useState(false);
    const [showConfPass, setShowConfPass] = useState(false);

    // ---------- ON NEXT --------- //
    const [step, setStep] = useState(0);
    const onChange = (nextStep) => {
        setStep(nextStep < 0 ? 0 : nextStep > 4 ? 4 : nextStep);
    };
    const onNext = () => onChange(step + 1);
    const onPrevious = () => onChange(step - 1);

    // -- Tombol Show Password -- //
    const shower = () => {
        setShowPass(!showPass);
    }
    const showerConf = () => {
        setShowConfPass(!showConfPass);
    }

    // -- Fungsi Get Error Message dari Error Code -- //
    const getErrorMessage = (errorCode) => {
        switch (errorCode) {
            case "E1":
                return "Sesi Anda telah berakhir. Silakan login kembali.";
            case "CE1":
            case "CE2":
                return "Data tidak valid. Silakan periksa kembali.";
            case "IF1":
                return "Data yang diminta tidak tersedia.";
            case "CE3":
                return "Kode tidak dapat digunakan.";
            case "SE1":
                return "Email tidak dapat digunakan.";
            case "PM1":
                return "Email atau password tidak valid.";
            case "PM2":
                return "Konfirmasi password tidak sesuai.";
            case "IF2":
                return "Data tidak lengkap.";
            case "EF1":
                return "Permintaan tidak dapat diproses.";
            case "OM1":
                return "Kode verifikasi tidak valid.";
            case "NC1":
                return "Konfirmasi password tidak sesuai.";
            case "AP1":
                return "Terjadi kesalahan sistem. Silakan coba kembali.";
            case "EX1":
                return "File tidak dapat diproses.";
            case "NX1":
                return "File belum dipilih.";
            case "AK1":
                return "Akses tidak valid.";
            case "FS1":
                return "Ukuran file melebihi batas maksimum yang diizinkan.";
            case "SQ1":
                return "Terjadi kesalahan sistem. Silakan coba kembali.";
            case "MN1":
                return "Gagal memproses file. Silakan coba kembali.";
            case "EV1":
                return "Data yang dikirim tidak valid.";
            case "NM1":
                return "Gagal mengirim notifikasi. Silakan coba kembali.";
            case "RL1":
                return "Terlalu banyak permintaan. Silakan coba kembali beberapa saat lagi.";
            default:
                return errorCode;
        }
    }

    // -------- Imput Email --------- //
    const changeEmail = (event) => {
        const value = event.target.value
        setEmail(value)
        // if(!value) {
        //     setErrorEmail('Maaf, email tidak boleh kosong!')
        // }else{
        //     setErrorEmail('')
        // }
    }

    const changePassword = (event) => {
        const value = event.target.value
        setPassword(value)
    }
    const changeConfPassword = (event) => {
        const value = event.target.value
        setConfPassword(value)
    }

    const sendEmail = () => {
        setErrorEmail(true)
        const data = JSON.stringify({"email": email});

        const config = {
        method: 'post',
        url: `${process.env.REACT_APP_BASE_ENDPOINT_BACKEND}/admin/sendOtp`,
        headers: { 
            'Content-Type': 'application/json'
        },
        data : data
        };

        axios(config)
        .then(function (response) {
            // Check if response contains error code
            if (response.data && response.data.error) {
                const errorCode = response.data.error;
                const message = getErrorMessage(errorCode);
                setErrorMessageEmail(message);
                setErrorEmail(false);
                setTimeout(() => {
                    setErrorEmail(true)
                    setErrorMessageEmail('')
                }, 5000)
                return;
            }

            if(response.status === 200){
                onNext();
                setPejet(true)
            }
        })
        .catch(function (error) {
            if (error.response && error.response.data && error.response.data.error) {
                const errorCode = error.response.data.error;
                const message = getErrorMessage(errorCode);
                setErrorMessageEmail(message);
                setErrorEmail(false);
                setTimeout(() => {
                    setErrorEmail(true)
                    setErrorMessageEmail('')
                }, 5000)
            } else {
                setErrorMessageEmail("Email tidak ditemukan.");
                setErrorEmail(false);
                setTimeout(() => {
                    setErrorEmail(true)
                    setErrorMessageEmail('')
                }, 5000)
            }
        });
    }

    const resendEmail = () => {
        setSuccessEmail(true)
        setErrorEmail(true)
        const data = JSON.stringify({
        "email": email
        });

        const config = {
        method: 'post',
        url: `${process.env.REACT_APP_BASE_ENDPOINT_BACKEND}/admin/sendOtp`,
        headers: { 
            'Content-Type': 'application/json'
        },
        data : data
        };

        axios(config)
        .then(function (response) {
            // Check if response contains error code
            if (response.data && response.data.error) {
                const errorCode = response.data.error;
                const message = getErrorMessage(errorCode);
                setErrorMessageEmail(message);
                setErrorEmail(false);
                setTimeout(() => {
                    setErrorEmail(true)
                    setErrorMessageEmail('')
                }, 5000)
                return;
            }

            if(response.status === 403){
                setErrorMessageEmail("Email tidak ditemukan.");
                setErrorEmail(false)
                setTimeout(() => {
                    setErrorEmail(true)
                    setErrorMessageEmail('')
                }, 5000)
            }
            if(response.status === 200){
                setSuccessEmail(false);
                handleReset()
                setTimeout(() => {
                    setSuccessEmail(true);
                },4000)
            }
        })
        .catch(function (error) {
            if (error.response && error.response.data && error.response.data.error) {
                const errorCode = error.response.data.error;
                const message = getErrorMessage(errorCode);
                setErrorMessageEmail(message);
                setErrorEmail(false);
                setTimeout(() => {
                    setErrorEmail(true)
                    setErrorMessageEmail('')
                }, 5000)
            } else {
                setErrorMessageEmail("Terjadi kesalahan. Silakan coba kembali.");
                setErrorEmail(false);
                setTimeout(() => {
                    setErrorEmail(true)
                    setErrorMessageEmail('')
                }, 5000)
            }
        });
    }

    const sendOTP = () => {
        setErrorOTP(true)
        const data = JSON.stringify({
            "email": email,
            "kodeOtp": otp
        });
          
        const config = {
            method: 'post',
            url: `${process.env.REACT_APP_BASE_ENDPOINT_BACKEND}/admin/verifikasiKodeOtp`,
            headers: { 
              'Content-Type': 'application/json'
            },
            data : data
        };
          
        axios(config)
        .then(function (response) {
            // Check if response contains error code
            if (response.data && response.data.error) {
                const errorCode = response.data.error;
                const message = getErrorMessage(errorCode);
                setErrorMessageOTP(message);
                setErrorOTP(false);
                setTimeout(() => {
                    setErrorOTP(true)
                    setErrorMessageOTP('')
                }, 5000)
                return;
            }

            if(response.status === 403) {
                setErrorMessageOTP("Kode verifikasi tidak valid.");
                setErrorOTP(false)
                setTimeout(() => {
                    setErrorOTP(true);
                    setErrorMessageOTP('')
                }, 5000)
            }
            if(response.status === 200){
                setApiKey(response.apiKey)
                onNext();
                setPejet(false)
            }
        })
        .catch(function (error) {
            if (error.response && error.response.data && error.response.data.error) {
                const errorCode = error.response.data.error;
                const message = getErrorMessage(errorCode);
                setErrorMessageOTP(message);
                setErrorOTP(false);
                setTimeout(() => {
                    setErrorOTP(true)
                    setErrorMessageOTP('')
                }, 5000)
            } else {
                setErrorMessageOTP("Kode verifikasi tidak valid.");
                setErrorOTP(false);
                setTimeout(() => {
                    setErrorOTP(true)
                    setErrorMessageOTP('')
                }, 5000)
            }
        });
    }

    const sendChangePassword = () => {
        setErrorPassword(true);
        const data = JSON.stringify({
            "email": email,
            "newPassword": password,
            "confirmPassword": confPassword
        });
          
        const config = {
            method: 'post',
            url: `${process.env.REACT_APP_BASE_ENDPOINT_BACKEND}/admin/changePasswordAdmin`,
            headers: { 
              'x-api-key': apiKey, 
              'Content-Type': 'application/json'
            },
            data : data
        };
          
        axios(config)
        .then(function (response) {
            // Check if response contains error code
            if (response.data && response.data.error) {
                const errorCode = response.data.error;
                const message = getErrorMessage(errorCode);
                setErrorKontenPassword(message);
                setErrorPassword(false);
                setTimeout(() => {
                    setErrorPassword(true);
                    setErrorKontenPassword('')
                }, 5000)
                return;
            }

            if(response.status === 403){
                setErrorKontenPassword('New Password dan Confirm Password tidak sama')
                setErrorPassword(false);
                setTimeout(() => {
                    setErrorPassword(true);
                    setErrorKontenPassword('')
                }, 5000)
            }
            if(response.status === 200){
                window.location.href = '/login-admin'
            }
        })
        .catch(function (error) {
            if (error.response && error.response.data && error.response.data.error) {
                const errorCode = error.response.data.error;
                const message = getErrorMessage(errorCode);
                setErrorKontenPassword(message);
                setErrorPassword(false);
                setTimeout(() => {
                    setErrorPassword(true);
                    setErrorKontenPassword('')
                }, 5000)
            } else {
                setErrorKontenPassword('Silahkan check kembali Password Anda')
                setErrorPassword(false);
                setTimeout(() => {
                    setErrorPassword(true);
                    setErrorKontenPassword('')
                }, 5000)
            }
        });
    }

    const [coba, setCoba] = useState(120);
    const [pejet, setPejet] = useState(false);

    useInterval(() => {
        setCoba(coba - 1);

        if(coba === 1) {
            setPejet(false)
        }

    },pejet ? 1000 : null);

    const formatTime = () => {
        const minutes = Math.floor(coba / 60);
        const seconds = coba % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    } 
    const handleReset = () => {
        setCoba(120);
        setPejet(true)
    }

    return (
        <React.Fragment>
            <style>
                {`
                    @keyframes slideDown {
                        from {
                            opacity: 0;
                            transform: translateY(-10px);
                            max-height: 0;
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                            max-height: 100px;
                        }
                    }
                `}
            </style>
        <Row style={{margin: '0px', height: '100vh', alignItems: 'center'}}>
            <Col md={12} lg={6} xl={6} style={{height: '100%', padding: '0px'}}>
                <img src={Welcome} style={{height: '-webkit-fill-available'}}/>
            </Col>

            <Col md={12} lg={6} xl={6} style={{padding: '0px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>

                <div style={{display: 'flex', justifyContent: 'center', marginRight: '50px'}}>
                    <img src={logoTelkom}/>
                </div>

                <div style={{marginTop: '50px', padding: '25px', boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.08)', borderRadius: '8px', width: '65%', marginRight: '50px'}}>
                {step === 0 && (
                    <>
                        <p style={{fontWeight: '700', fontSize: '30px', color: '#F56565', textAlign: 'center'}}>Lupa Kata Sandi?</p>
                        {!errorEmail && (
                            <Alert 
                                color="danger" 
                                style={{ 
                                    textAlign: 'center', 
                                    backgroundColor: '#FEE2E2', 
                                    color: '#DC2626', 
                                    borderColor: '#FCA5A5', 
                                    borderLeft: '4px solid #DC2626',
                                    margin: '10px 0px 20px 0px', 
                                    borderRadius: '6px',
                                    padding: '12px 16px',
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    animation: 'slideDown 0.3s ease-out',
                                    boxShadow: '0 2px 4px rgba(220, 38, 38, 0.1)'
                                }}
                                onClose={() => {
                                    setErrorEmail(true);
                                    setErrorMessageEmail('');
                                }}
                                toggle={() => {
                                    setErrorEmail(true);
                                    setErrorMessageEmail('');
                                }}
                            >
                                <i className="ri-error-warning-line" style={{ fontSize: '18px' }}></i>
                                {errorMessageEmail || "Email tidak ditemukan."}
                            </Alert>
                        )}
                        <div className="mb-4">
                            <label style={{fontSize: '14px'}} className="form-label">Email</label>
                            <input style={{fontSize: '14px'}} value={email} onChange={changeEmail} type="email" className="form-control" id="email" placeholder="Enter email address" required/>
                        </div>

                        <div className="text-center mt-4">
                            <Button style={{fontSize: '14px'}} color="success" className="w-100" onClick={() => {
                                sendEmail();
                                // onNext();
                                }}>
                                Kirim
                            </Button>
                        </div>
                    </>
                )}
                {step === 1 && (
                    <>
                    <p style={{fontWeight: '700', fontSize: '30px', color: '#F56565', textAlign: 'center'}}>Verifikasi OTP</p>
                    <Alert color="info" style={{ textAlign: 'center', backgroundColor: '#DBEAFE', color: '#1E40AF', borderColor: '#93C5FD', borderLeft: '4px solid #1E40AF', margin: '10px 0px', borderRadius: '6px', padding: '12px 16px', fontSize: '14px', fontWeight: '500', animation: 'slideDown 0.3s ease-out' }}>
                       <i className="ri-time-line" style={{ fontSize: '18px', marginRight: '8px' }}></i>
                       OTP akan Kadaluarsa {formatTime()}
                    </Alert>
                    {!errorOTP && errorMessageOTP && (
                        <Alert 
                            color="danger" 
                            style={{ 
                                textAlign: 'center', 
                                backgroundColor: '#FEE2E2', 
                                color: '#DC2626', 
                                borderColor: '#FCA5A5', 
                                borderLeft: '4px solid #DC2626',
                                margin: '10px 0px 20px 0px', 
                                borderRadius: '6px',
                                padding: '12px 16px',
                                fontSize: '14px',
                                fontWeight: '500',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px',
                                animation: 'slideDown 0.3s ease-out',
                                boxShadow: '0 2px 4px rgba(220, 38, 38, 0.1)'
                            }}
                            onClose={() => {
                                setErrorOTP(true);
                                setErrorMessageOTP('');
                            }}
                            toggle={() => {
                                setErrorOTP(true);
                                setErrorMessageOTP('');
                            }}
                        >
                            <i className="ri-error-warning-line" style={{ fontSize: '18px' }}></i>
                            {errorMessageOTP}
                        </Alert>
                    )}
                    {!successEmail && (
                        <Alert 
                            color="success" 
                            style={{ 
                                textAlign: 'center', 
                                backgroundColor: '#F0FFF4', 
                                color: '#38A169', 
                                borderColor: '#9AE6B4', 
                                borderLeft: '4px solid #38A169',
                                margin: '10px 0px 20px 0px', 
                                borderRadius: '6px',
                                padding: '12px 16px',
                                fontSize: '14px',
                                fontWeight: '500',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px',
                                animation: 'slideDown 0.3s ease-out',
                                boxShadow: '0 2px 4px rgba(56, 161, 105, 0.1)'
                            }}
                            onClose={() => {
                                setSuccessEmail(true);
                            }}
                            toggle={() => {
                                setSuccessEmail(true);
                            }}
                        >
                            <i className="ri-checkbox-circle-line" style={{ fontSize: '18px' }}></i>
                            Silahkan check email Anda kembali
                        </Alert>
                    )}
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                        <ReactInputVerificationCode value={otp} onChange={(value) => {
                            setOTP(value);
                            // Reset error when user starts typing
                            if (errorMessageOTP) {
                                setErrorOTP(true);
                                setErrorMessageOTP('');
                            }
                        }}/>
                    </div>
                    <p style={{textAlign: 'center', marginTop: '20px', fontSize: '14px'}}> 
                        Anda masuk belum menerima kode? 
                        <span style={{fontWeight: '700', fontSize: '16px', color: '#F56565', cursor: 'pointer'}} onClick={() => {
                            resendEmail();
                            }}>Kirim Ulang</span>
                    </p>
                    
                    <div className="text-center mt-4">
                        <Button style={{fontSize: '14px'}} color="success" className="w-100" onClick={() => {
                            sendOTP();
                            // onNext(); 
                            }}>
                            Verifikasi
                        </Button>
                    </div>
                    </>
                )}
                {step === 2 && (
                    <>
                    {/* ---- Masukin Data Password ---- */}
                    <p style={{fontWeight: '700', fontSize: '30px', color: '#F56565', textAlign: 'center'}}>Kata Sandi Baru</p>
                    {!errorPassword && errorKontenPassword && (
                        <Alert 
                            color="danger" 
                            style={{ 
                                textAlign: 'center', 
                                backgroundColor: '#FEE2E2', 
                                color: '#DC2626', 
                                borderColor: '#FCA5A5', 
                                borderLeft: '4px solid #DC2626',
                                margin: '10px 0px 20px 0px', 
                                borderRadius: '6px',
                                padding: '12px 16px',
                                fontSize: '14px',
                                fontWeight: '500',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px',
                                animation: 'slideDown 0.3s ease-out',
                                boxShadow: '0 2px 4px rgba(220, 38, 38, 0.1)'
                            }}
                            onClose={() => {
                                setErrorPassword(true);
                                setErrorKontenPassword('');
                            }}
                            toggle={() => {
                                setErrorPassword(true);
                                setErrorKontenPassword('');
                            }}
                        >
                            <i className="ri-error-warning-line" style={{ fontSize: '18px' }}></i>
                            {errorKontenPassword}
                        </Alert>
                    )}
                    <div className="mb-3">
                        <Label style={{fontSize: '14px'}} className="form-label" htmlFor="password-input">New Password</Label>
                            <div className="position-relative auth-pass-inputgroup">
                                <Input style={{fontSize: '14px'}} value={password} onChange={changePassword} type={showPass ? "text" : "password"} className="form-control pe-5" placeholder="Enter password" id="password-input" pattern='^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{8,24}$' title="Password 8-24 character, setidaknya ada satu huruf kecil, huruf besar, angka dan simbol" required minLength={8} maxLength={24}/>
                                <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" onClick={shower} type="button" id="password-addon"><i className="ri-eye-fill align-middle"></i></button>
                            </div>
                            <p style={{margin: '0', color: '#ED8936', fontSize: '12px'}}>*Kata sandi minimal 8 karakter harus terdiri atas huruf kapital, angka, dan simbol.</p>
                    </div>

                    {/* ---- Masukin Data ConfPassword ---- */}
                    <div className="mb-3">
                        <Label style={{fontSize: '14px'}} className="form-label" htmlFor="password-conf">Confirm Password</Label>
                            <div className="position-relative auth-pass-inputgroup">
                                <Input style={{fontSize: '14px'}} value={confPassword} onChange={changeConfPassword} type={showConfPass ? "text" : "password"} className="form-control pe-5" placeholder="Enter password" id="password-conf" required minLength={8} maxLength={24}/>
                                <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" onClick={showerConf} type="button" id="password-addon"><i className="ri-eye-fill align-middle"></i></button>
                            </div>
                    </div>

                    <div className="text-center mt-4">
                        <Button style={{fontSize: '14px'}} color="success" className="w-100" onClick={() => {
                            sendChangePassword();
                            // onNext();
                            }}>
                            Ganti Kata Sandi
                        </Button>
                    </div>
                    </>
                )}
                </div>

                {step === 0 && (
                    <>
                    <div style={{ marginRight: '50px', fontSize: '14px'}} className="mt-5 text-center">
                        <p className="mb-0">Ingat Password ? <Link to="/login-admin" className="fw-semibold text-primary text-decoration-underline"> Klik Disini </Link> </p>
                    </div>
                    </>
                )}

            </Col>
        </Row>
        </React.Fragment>
    );
};

export default CoverPasswReset;